import React, {PureComponent} from "react"
import {Emoji} from "emoji-mart"
import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

import {ResponsiveFlexWrapper, FlexWrapper, Flex} from "./styled"

interface Props {
  isMobile: boolean
}

class ActivationSteps extends PureComponent<Props> {
  render() {
    const {isMobile} = this.props
    const step1Text = isMobile ? "medical.activation.step.text1" : "medical.activation.desktopStep.text1"
    const step2Text = isMobile ? "medical.activation.step.text2" : "medical.activation.desktopStep.text2"
    const step3Text = isMobile ? "medical.activation.step.text3" : "medical.activation.desktopStep.text3"
    const step4Text = isMobile ? "medical.activation.step.text4" : "medical.activation.desktopStep.text4"

    return (
      <ResponsiveFlexWrapper>
        <FlexWrapper>
          <Flex>
            <Emoji emoji={{id: "one"}} size={14} set="apple" />
            <Body small marginBottom={1} marginLeft={1} display="inline">
              <FormattedMessage id={step1Text} />
            </Body>
          </Flex>
          <Flex>
            <Emoji emoji={{id: "two"}} size={14} set="apple" />
            <Body small marginBottom={1} marginLeft={1} display="inline">
              <FormattedMessage id={step2Text} />
            </Body>
          </Flex>
          <Flex>
            <Emoji emoji={{id: "three"}} size={14} set="apple" />
            <Body small marginBottom={1} marginLeft={1} display="inline">
              <FormattedMessage id={step3Text} />
            </Body>
          </Flex>
          <Flex>
            <Emoji emoji={{id: "four"}} size={14} set="apple" />
            <Body small marginBottom={1} marginLeft={1} display="inline">
              <FormattedMessage id={step4Text} />
            </Body>
          </Flex>
        </FlexWrapper>
      </ResponsiveFlexWrapper>
    )
  }
}

export default ActivationSteps
